import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "../../../../context/themeContext";
import AgeRanges from "./components/age-range";
import Basics from "./components/basics";
import Contact from "./components/contact";
import ExprienceLevel from "./components/exprience-level";
import ProjectCoverImage from "./components/project-cover-image.js";
import RolesList from "./components/RolesList";
import styles from "./style.module.css";
// import { creatorDefaultImages } from "../../../../constants";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { node_server } from "../../../../constants/index.js";
import useManageProjects from "../../../../hooks/useManageProjects.js";
import { setEditNavigate } from "../../../../store/slices/profile/manageProjectsSlice.js";
import {
	setCroppedImage,
	setOriginalProjectImage,
} from "../../../../store/slices/profile/projectCoverImageSlice.js";
import { setRoles } from "../../../../store/slices/profile/rolesSlice.js";

const ProjectForm = () => {
	const { id } = useParams();
	const { theme } = useTheme();
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [selectedExprienceLevel, setSelectedExprienceLevel] =
		useState("Advanced or higher");
	const [title, setTitle] = useState("");
	const [primaryEntity, setPrimaryEntity] = useState("");
	const [description, setDescription] = useState("");
	const [country, setCountry] = useState("");
	const [locationType, setLocationType] = useState("Local");
	const [emailAddress, setEmailAddress] = useState("");
	const dispatch = useDispatch();
	const roles = useSelector((state) => state.roles.value);
	const user = useSelector((state) => state.user.value);
	const { croppedImage, originalProjectImage } = useSelector(
		(state) => state.projectCoverImage,
	);
	const [ageRanges, setAgeRanges] = useState([]);
	const [status, setStatus] = useState();
	const [project, setProject] = useState();
	const navigate = useNavigate();
	const { editNavigate } = useSelector((state) => state.manageProjects);
	const { fetchProjects } = useManageProjects();

	const setProjectFields = (project) => {
		setSelectedCategory(project.category);
		setSelectedExprienceLevel(project.experience_level);
		setTitle(project.title);
		setPrimaryEntity(project.primary_entity);
		setDescription(project.description);
		setCountry(project.location_name);
		setLocationType(project.location_type);
		setEmailAddress(project.contact_email);
		dispatch(setCroppedImage(project.project_cover_image));
		setStatus(project.status);
		setProject(project);
		dispatch(setOriginalProjectImage(project.original_cover_image));
	};

	useEffect(() => {
		const fetchProject = async () => {
			const response = await axios.get(
				`${node_server}/api/projects/details/${id}`,
				{
					withCredentials: true,
				},
			);

			if (response.status !== 200) console.log(response.data);
			if (response.data) setProjectFields(response.data[0]);
		};

		const fetchRoles = async () => {
			const { data, error } = await axios.get(
				`${node_server}/api/projects/roles/${id}`,
				{
					withCredentials: true,
				},
			);

			console.log({ data }, "triggered data");
			if (error) console.log(error);
			if (data.length > 0) {
				const tempRoles = data.map((item, index) => {
					return {
						selectedCategory: item.category,
						selectedSkill: item.creator_skill,
						selectedSpecialty: item.speciality,
						num: index + 1,
					};
				});
				console.log({ tempRoles }, "triggered tempRoles");
				dispatch(setRoles(tempRoles));
			}
		};

		const fetchAgeRanges = async () => {
			const { data, error } = await axios.get(
				`${node_server}/api/projects/age-ranges/${id}`,
				{
					withCredentials: true,
				},
			);

			if (error) console.log(error);
			if (data) {
				const tempAgeRanges = data.map((item) => {
					return item.age_range;
				});
				setAgeRanges(tempAgeRanges);
			}
		};

		fetchProject();
		fetchRoles();
		fetchAgeRanges();
	}, [id]);

	const basicProps = {
		title: title,
		setTitle: setTitle,
		primaryEntity,
		setPrimaryEntity,
		description: description,
		setDescription: setDescription,
		country: country,
		setCountry: setCountry,
		selectedCategory,
		setSelectedCategory,
		locationType,
		setLocationType,
	};

	const contactProps = {
		emailAddress: emailAddress,
		setEmailAddress: setEmailAddress,
	};

	const exprienceProps = {
		selectedExprienceLevel,
		setSelectedExprienceLevel,
	};

	const ageRangesProps = {
		ageRanges,
		setAgeRanges,
	};

	const handleSubmitProject = async () => {
		const { error: projectRolesError } = await axios.delete(
			`${node_server}/api/projects/roles?projectId=${id}`,
			{
				withCredentials: true,
			},
		);
		if (projectRolesError) console.log(projectRolesError);

		const { error: projectAgeRangesError } = await axios.delete(
			`${node_server}/api/projects/age-ranges?projectId=${id}`,
			{
				withCredentials: true,
			},
		);
		if (projectAgeRangesError) console.log(projectAgeRangesError);

		let original = originalProjectImage || null;
		let cropp = croppedImage || null;

		// if (originalProjectImage === null && selectedCreatorTypes.length !== 0) {
		//   const targetCreatorType = selectedCreatorTypes[0].category;
		//   const targetImage = creatorDefaultImages[targetCreatorType];
		//   original = targetImage;
		//   cropp = targetImage;
		// }

		const response = await axios.put(
			`${node_server}/api/projects/details/${id}`,
			{
				title: title,
				user_id: user.id,
				primary_entity: primaryEntity,
				description: description,
				location: country,
				status: status,
				contact_email: emailAddress,
				submitted_by: user.id,
				created_at: new Date(),
				project_cover_image: cropp,
				original_cover_image: original,
				category: selectedCategory.category,
				location_type: locationType,
				location_name: country,
				experience_level: selectedExprienceLevel,
			},
			{
				withCredentials: true,
			},
		);
		const error = response.status !== 200 ? response.data : null;
		if (error) console.error(error);

		await roles.map(async (item) => {
			const record = {
				project_id: project.id,
				category: item.selectedCategory.category,
				creator_skill: item.selectedSkill.skill,
				speciality: item.selectedSpecialty.speciality,
			};

			const { error } = await axios.post(
				`${node_server}/api/projects/roles`,
				record,
				{
					withCredentials: true,
				},
			);
			if (error) console.error(error);
		});

		const { error: ageRangesError } = await axios.post(
			`${node_server}/api/projects/age-ranges`,
			{
				projectId: project.id,
				ageRanges: ageRanges,
			},
			{ withCredentials: true },
		);

		if (ageRangesError) console.error(ageRangesError);
		dispatch(setRoles([]));
		handleCancel();

		dispatch(
			setCroppedImage(
				"https://test-assets.collab-with-lynx.com/project-cover-image-0.48025884403475594-v-1710946773530",
			),
		);
		dispatch(setOriginalProjectImage(null));
		fetchProjects();
	};

	const handleCancel = () => {
		if (editNavigate) {
			navigate(`/project-manage`);
			dispatch(setEditNavigate(false));
		} else {
			navigate(`/projects/${id}`);
		}
		dispatch(
			setCroppedImage(
				"https://test-assets.collab-with-lynx.com/project-cover-image-0.48025884403475594-v-1710946773530",
			),
		);
		dispatch(setOriginalProjectImage(null));
	};

	return (
		<Box component="form" className={styles.projectForm}>
			<ProjectCoverImage project={project} />
			<Basics {...basicProps} />
			<RolesList roles={roles} />
			<AgeRanges {...ageRangesProps} />
			<ExprienceLevel {...exprienceProps} />
			<Contact {...contactProps} />
			<Box className={styles.button}>
				<Button
					variant="contained"
					onClick={handleSubmitProject}
					fullWidth
				>
					Save
				</Button>
				<Button
					onClick={handleCancel}
					variant="text"
					fullWidth
					sx={{
						color: theme.palette.darkgrey.darkgrey400,
						textTransform: "capitalize",
						fontSize: "16px",
						fontWeight: "500",
						p: "0px",
					}}
				>
					Cancel
				</Button>
			</Box>
		</Box>
	);
};

export default ProjectForm;
